const doc = [({"zh_tw":({"adminConstantHotelDisplayCalendarType":({"displayed":"展示", "hidden":"不顯示", "hideButton":"隱藏顯示價格按鈕"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;